import { useEffect, useState } from "react";
import api from "../lib/api";
import { displayName } from "../lib/anagConfig";
import SubjectSelect from "./SubjectSelect";
import PraticaSummaryChips from "./PraticaSummaryChips";
import NuovoProfessionistaDialog from "./NuovoProfessionistaDialog";
import { Pencil } from "lucide-react";

// Campo "Istruttore" della pratica: selezione da anagrafica, matita per modificarne la scheda e recapiti.
export default function IstruttoreField({ value, onChange, testId }) {
  const [list, setList] = useState([]);
  const [edit, setEdit] = useState(null);
  const [ver, setVer] = useState(0);
  useEffect(() => { api.get("/anagrafiche/istruttori").then(({ data }) => setList(data || [])).catch(() => setList([])); }, [ver]);
  const rec = value ? list.find((r) => displayName(r) === value) : null;
  return (
    <div>
      <div className="flex items-center gap-1.5">
        <div className="flex-1"><SubjectSelect key={ver} atype="istruttori" value={value} onChange={onChange} testId={testId} /></div>
        <button type="button" disabled={!rec} onClick={() => setEdit(rec)} data-testid={`${testId}-edit`} title={rec ? "Modifica scheda istruttore" : "Nessun istruttore selezionato"}
          className="mt-1.5 shrink-0 h-9 w-9 flex items-center justify-center rounded-md border border-teal-500/40 text-teal-600 hover:bg-teal-500/10 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent"><Pencil className="h-4 w-4" /></button>
      </div>
      {rec && <PraticaSummaryChips rec={rec} testId={testId} waCategory="istruttore" />}
      {edit && (
        <NuovoProfessionistaDialog open atype="istruttori" label="Istruttore" editRec={edit} initialName={value}
          onSaved={(r) => { setEdit(null); setVer((v) => v + 1); const n = displayName(r); if (n && n !== value) onChange(n); }} onCancel={() => setEdit(null)} />
      )}
    </div>
  );
}
